<template>
  <div class="screen-dialog" v-if="!isDynamicLoad || isShow" :aria-hidden="!isShow">
    <div
      class="midddialog"
      v-show="isShow"
      ref="mask"
      role="dialog"
      tabindex="-1"
      aria-modal="true"
    >
      <div class="midddialog-mask" @click="clickMask"></div>
      <div class="midddialog-main" ref="content">
        <slot></slot>
      </div>
      <div
        class="midddialog-close"
        role="button"
        aria-label="close"
        @click.stop="clickBtn"
        v-if="isShowClose"
      ></div>
      <div class="midddialog-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { disableBodyScroll, enableBodyScroll } from '../../../common/scroll';

/**
 * 全屏弹窗
 */
@Component
export default class ScreenDialog extends Vue {
  /** 点击遮罩层是否关闭 */
  @Prop({ default: false }) clickMaskHide!: boolean;
  /** 是否展示关闭按钮 */
  @Prop({ default: true }) isShowClose!: boolean;
  /** 是否挂载到body中 */
  @Prop({ default: false }) isAppendToBody!: boolean;
  /** 是否动态加载到dom中 */
  @Prop({ default: false }) isDynamicLoad!: boolean;
  isShow = false;
  @Emit('show')
  show() {
    this.isShow = true;
  }
  @Emit('hide')
  hide() {
    this.isShow = false;
  }
  @Emit('clickBtn')
  private clickBtn() {
    this.hide();
  }
  @Emit('clickMask')
  private clickMask() {
    if (this.clickMaskHide) this.hide();
  }
  @Watch('isShow')
  private handleIsShowChange() {
    if (this.isShow) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }

  private mounted() {
    if (this.isAppendToBody) {
      document.body.appendChild(this.$el);
    }
  }

  private destroyed() {
    if (this.isAppendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    enableBodyScroll();
  }
}
</script>

<style lang="less" scoped>
@rem: 200rem;

.midddialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 900;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 900;
    background-color: rgba(0, 0, 0, 0.7);
  }
  &-main {
    z-index: 901;
    box-sizing: border-box;
    position: relative;
  }
  &-close {
    width: 64 / @rem;
    height: 64 / @rem;
    background-image: url('~@wphk-ui/assets/image/btn_close.png');
    background-size: 100% 100%;
    z-index: 902;
    margin-top: 34 / @rem;
  }
  &-footer {
    z-index: 999;
  }
}
</style>
